import React from 'react';
import { motion } from 'framer-motion';
export function FinalCTASection() {
  return <section className="bg-navy py-24 px-4 text-center border-t-4 border-safety-red relative overflow-hidden" data-id="element-24">
      {/* Subtle background texture */}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'radial-gradient(#ffffff 1px, transparent 1px)',
      backgroundSize: '24px 24px'
    }} data-id="element-25"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-26">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-27">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-6 leading-tight" data-id="element-28">
            Don't Wait for the Emergency to Realize You Weren't Ready
          </h2>

          <p className="text-xl md:text-2xl font-body text-gray-300 mb-10" data-id="element-29">
            Join thousands of prepared families. Instant digital download.
          </p>

          <a href="#pricing" className="inline-block bg-cta-green hover:bg-green-700 text-white font-heading font-bold text-xl md:text-2xl px-10 py-6 rounded-sm transition-colors shadow-2xl border-2 border-green-500 uppercase tracking-widest w-full sm:w-auto" data-id="element-30">
            Secure Your Family's Legacy Now
          </a>

          <p className="mt-6 font-heading text-sm text-gray-400 uppercase tracking-widest" data-id="element-31">
            Just $6.39 — Instant Access
          </p>
        </motion.div>
      </div>
    </section>;
}